<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<h1 id="confirmationHeader" class="margin-top-20">Thank you for filing your claim</h1>
<div class="nw-container bolt-space-bottom-sm">
    <div class="confirmation-success" [ngClass]="{'auto-box-info': isAuto, 'workerscomp-box-info': isWC, 'general-liability-box-info': isGL, 'property-box-info': isProperty }">
        <img src="assets\images\successcheckmark.svg">
        <p>Your claim was successfully submitted.</p>
        <p>We'll contact you within 1 or 2 business days to discuss the details of your claim.</p>
        <p>
            <small>
                <em>We'll send a confirmation email to the address we have on file once your claim is processed.</em>
            </small>
        </p>
        <hr *ngIf="policyType === 'Commercial Property'">
        <p *ngIf="policyType === 'Commercial Property'" style="text-align: left">Protect your property from further
            damage
            with these tips:</p>
        <ul *ngIf="policyType === 'Commercial Property'">
            <li><span>Make reasonable temporary repairs to avoid further damage.</span></li>
            <li><span>Take pictures of the damaged property before it's repaired and/or make a list of the damaged
                    property.</span></li>
            <li><span>Do not discard any items.</span></li>
            <li><span>Secure windows and doors.</span></li>
            <li><span>Keep receipts of expenses you incur as a result of the damage to your property.</span></li>
        </ul>
    </div>
    <div style="text-align:center;">
        <button id="policyListButton" title="Return to policy list" class="btn btn-primary preferred equal-width margin-top-20 margin-bottom-20" (click)="navigateToClaimsList()">Return to Policy
            Claims List</button>
    </div>
</div>
<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
